import { createAction } from "@reduxjs/toolkit";

export const FETCH_LIST_COURSEWARE_ACTIVITY = 'FETCH_LIST_COURSEWARE_ACTIVITY';

export const fetchListCoursewareActivity = createAction(FETCH_LIST_COURSEWARE_ACTIVITY, (filters: any) => ({
  payload: {
    filters
  }
}));
